import { render, staticRenderFns } from "./mask.vue?vue&type=template&id=6828d3d1&scoped=true"
import script from "./mask.vue?vue&type=script&lang=js"
export * from "./mask.vue?vue&type=script&lang=js"
import style0 from "./mask.vue?vue&type=style&index=0&id=6828d3d1&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828d3d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6828d3d1')) {
      api.createRecord('6828d3d1', component.options)
    } else {
      api.reload('6828d3d1', component.options)
    }
    module.hot.accept("./mask.vue?vue&type=template&id=6828d3d1&scoped=true", function () {
      api.rerender('6828d3d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/componentsUI/mask.vue"
export default component.exports